module.exports = __webpack_public_path__ + "img/maze_rhombus_g.16b6a5d3.svg";